import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'MoreTagsChip' })({
    root: {
        background: 'linear-gradient(249deg, #FF8B61 7.18%, #D92E7F 172.88%)'
    },
    label: {
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        color: '#FFF',
        fontSize: 12,
        fontWeight: 500,
        lineHeight: '100%'
    },
    bold: {
        fontWeight: 700
    }
});
